import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery, useMutation, gql } from '@apollo/client';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';

const UPLOAD_URL = 'https://new.trydoobie.com/wp-content/reactpress/apps/doobie/scripts/upload.php';

const FETCH_CART_DETAILS = gql`
  query FetchCartDetails($retailerId: ID!, $checkoutId: ID!) {
    checkout(retailerId: $retailerId, id: $checkoutId) {
      id
      pricingType
      orderType
      priceSummary {
        taxes 
        subtotal
        total
        discounts
        rewards
      }   
      
      
              
      items {
      
      
      
        id
        option
        product {
          image      
          name
          id
          brand {
            name
          }
          
          
          
          variants  {
            option
            priceRec
            specialPriceRec
          }
        }
        quantity
      }   
      redirectUrl
    }
  }
`;

const UPDATE_QUANTITY = gql`
  mutation UpdateQuantity($checkoutId: ID!, $itemId: ID!, $quantity: Int!, $retailerId: ID!) {
    updateQuantity(
      checkoutId: $checkoutId
      itemId: $itemId
      quantity: $quantity
      retailerId: $retailerId
    ) {
      items {
        id
        option
        quantity
      }
      priceSummary {
        taxes
        subtotal
        total
        discounts
        rewards
      }
    }
  }
`;

const REMOVE_ITEM_FROM_CHECKOUT = gql`
  mutation RemoveItemFromCheckout($retailerId: ID!, $checkoutId: ID!, $itemId: ID!) {
    removeItem(retailerId: $retailerId, checkoutId: $checkoutId, itemId: $itemId) {
      id
      pricingType
      orderType
      priceSummary {
        taxes
        subtotal
        total
        discounts
        rewards
      }
      items {
        id
        option
        quantity
        product {
          image
          name
          id
          brand {
            name
          }
          variants {
            option
            priceRec
            specialPriceRec
          }
        }
      }
    }
  }
`;

const CheckoutForm = ({ retailerId, checkoutId }) => {
    const { register, handleSubmit } = useForm();
    const { loading, error, data, refetch } = useQuery(FETCH_CART_DETAILS, {
        variables: { retailerId, checkoutId },
    });
    const [errorMessage, setErrorMessage] = useState(""); // State to store error message
    const [loadingSpinner, setLoadingSpinner] = useState(false);

    useEffect(() => {
        const spinnerObserver = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                const ajaxSpinner4 = document.querySelector('#gform_ajax_spinner_4.gform-loader');
                const ajaxSpinner5 = document.querySelector('#gform_ajax_spinner_5.gform-loader');
                const strongHoldActive = document.querySelector('#stronghold-pay-iframe');

                if (ajaxSpinner4 || ajaxSpinner5 || strongHoldActive) {
                    setLoadingSpinner(true);
                } else {
                    setLoadingSpinner(false);
                }
            }
        });

        spinnerObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        return () => {
            spinnerObserver.disconnect();
        };
    }, []);

    const [cartItems, setCartItems] = useState([]);
    const [priceSummary, setPriceSummary] = useState(null);
    const [buttonText, setButtonText] = useState('Place Order');

    const [updateQuantity] = useMutation(UPDATE_QUANTITY, {
        onError: (error) => {
            console.error("GraphQL Error Details:", error); // Log full error object
            const message =
                error?.graphQLErrors?.[0]?.message ||
                error?.message ||
                "An error occurred while updating the quantity.";
            console.log("Extracted Error Message:", message); // Log extracted message
            setErrorMessage(message); // Set the error message in state
        },
    });
    useEffect(() => {
        console.log("Updated Error Message State:", errorMessage);
    }, [errorMessage]);

    const [removeItem] = useMutation(REMOVE_ITEM_FROM_CHECKOUT);
    const [couponCode, setCouponCode] = useState('');
    const [appliedDiscount, setAppliedDiscount] = useState(null);
    const [ourDiscount, setOurDiscount] = useState(0);
    const [tipAmount, setTipAmount] = useState(0);
    const [deliveryFee, setDeliveryFee] = useState(0);
    const [complianceFee, setComplianceFee] = useState(0); // Tracks the calculated compliance fee


    const [complianceDetails, setComplianceDetails] = useState(null); // Holds compliance fee details
    const [paymentMethod, setPaymentMethod] = useState(''); // Tracks the selected payment method

    const [deliveryFeeDetails, setDeliveryFeeDetails] = useState({
        scheduled: 500,
        express: 1000
    });



    useEffect(() => {
        console.log("Effect triggered");
        console.log("Compliance Details:", complianceDetails);  // Log to check if complianceDetails are available
        console.log("Price Summary:", priceSummary);  // Log to check if priceSummary is available
        console.log("Payment Method:", paymentMethod);  // Log the current payment method

        if (!complianceDetails || !priceSummary) {
            console.log("Exiting effect early: Missing compliance details or price summary");
            return; // Wait for both complianceDetails and priceSummary to be available
        }

        const calculateComplianceFee = () => {
            if (paymentMethod === 'Stronghold ACH' && priceSummary.total) {
                const { percentage, value } = complianceDetails;
                const calculatedFee = (complianceDetails?.percentage || 0) === 0 ||
                (complianceDetails?.value || 0) === 0
                    ? 0
                    : (priceSummary.total * complianceDetails.percentage + complianceDetails.value) / 100;



                setComplianceFee(calculatedFee); // Set the compliance fee based on percentage and value from API


                const complianceFeeElement = document.querySelector('input[name="input_48"]');
                if (complianceFeeElement) {
                    complianceFeeElement.value = calculatedFee.toFixed(2);
                    complianceFeeElement.dispatchEvent(new Event('change', { bubbles: true }));
                }
                console.log("Calculated Compliance Fee:", calculatedFee); // Log the calculated compliance fee
            } else {

                const complianceFeeElement = document.querySelector('input[name="input_48"]');
                if (complianceFeeElement) {
                    complianceFeeElement.value =0;
                    complianceFeeElement.dispatchEvent(new Event('change', { bubbles: true }));
                }

                setComplianceFee(0); // Set to 0 if another payment method is selected
                console.log("Compliance fee set to 0 (Non-Stronghold ACH payment method)");
            }
        };

        calculateComplianceFee(); // Trigger the calculation when dependencies change
    }, [complianceDetails, priceSummary, paymentMethod]); // Re-run effect when these change

    useEffect(() => {
        const updateDeliveryLabels = () => {
            const scheduledLabel = document.querySelector('label[for^="choice_"][for$="_19_0"]');
            const expressLabel = document.querySelector('label[for^="choice_"][for$="_19_1"]');

            // Format the fee values in dollars
            const scheduledFeeText = `$${(deliveryFeeDetails.scheduled / 100).toFixed(2)}`;
            const expressFeeText = `$${(deliveryFeeDetails.express / 100).toFixed(2)}`;

            // Update the labels if they exist
            if (scheduledLabel) {
                scheduledLabel.textContent = `Scheduled (${scheduledFeeText})`;
            }

            if (expressLabel) {
                expressLabel.textContent = `Priority (${expressFeeText}) Your driver will prioritize delivery of your Doobie!`;
            }
        };

        let mutationTimeout;
        const throttledLabelUpdate = () => {
            if (mutationTimeout) clearTimeout(mutationTimeout);
            mutationTimeout = setTimeout(() => {
                updateDeliveryLabels();
            }, 100); // Adjust debounce time as needed
        };

        const observeFormChanges = () => {
            const formContainer = document.querySelector('.newcheckoutwrapper'); // Adjust this selector to your form container
            if (formContainer && 'MutationObserver' in window) {
                const observer = new MutationObserver(() => {
                    throttledLabelUpdate();
                });

                // Observe changes to the form's child elements
                observer.observe(formContainer, { childList: true, subtree: true });

                // Return a cleanup function to disconnect the observer
                return () => {
                    observer.disconnect();
                    if (mutationTimeout) clearTimeout(mutationTimeout);
                };
            }
            return () => {};
        };

        // Update labels initially and set up observer for dynamic changes
        updateDeliveryLabels();
        const cleanupObserver = observeFormChanges();

        // Cleanup on component unmount
        return cleanupObserver;
    }, [deliveryFeeDetails]);

    useEffect(() => {
        let previousValue = null;

        const updatePaymentMethod = () => {
            const dropdown = document.querySelector('select[name="input_9"]');
            if (dropdown && dropdown.value !== previousValue) {
                previousValue = dropdown.value;
                setPaymentMethod(dropdown.value); // Update payment method state
                console.log("Payment method updated to:", dropdown.value); // Debugging output
            }
        };

        const attachListener = () => {
            const dropdown = document.querySelector('select[name="input_9"]');
            if (dropdown) {
                dropdown.addEventListener('change', updatePaymentMethod);
            }
        };

        const detachListener = () => {
            const dropdown = document.querySelector('select[name="input_9"]');
            if (dropdown) {
                dropdown.removeEventListener('change', updatePaymentMethod);
            }
        };

        // Initial setup
        attachListener();

        // Observe DOM changes
        const observer = new MutationObserver(() => {
            detachListener(); // Remove previous listener if the element was replaced
            attachListener(); // Attach the listener to the new element
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true, // Monitor attribute changes
            attributeFilter: ['class', 'style'], // Specifically monitor changes to class/style
        });

        // Cleanup
        return () => {
            detachListener();
            observer.disconnect(); // Stop observing DOM changes
        };
    }, [setPaymentMethod]);




    useEffect(() => {
        const almaUrl = "https://www.almapos.com/api/store_checkout_times";

        fetch(almaUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `token=${retailerId}`
        })
            .then(response => response.json())
            .then(storedetails => {
                var minimum = storedetails.minimum_spend;
                window.minimum = minimum;
                const deliveryMinElement = document.querySelector('.deliverymin');
                if (deliveryMinElement) {
                    deliveryMinElement.textContent = `$${minimum}`;
                }

                const areaId =  localStorage.getItem('areaId');



                const achPercentage = parseFloat(storedetails.areas[areaId].ach_convenience_percentage) / 100; // Convert percentage to decimal
                const achValue = parseFloat(storedetails.areas[areaId].ach_convenience_value);  // Get the fixed value

                console.log("fee before conversion");

                console.log(storedetails.areas[areaId].scheduledDeliveryFee);

                const scheduledDeliveryFee = parseFloat(storedetails.areas[areaId].scheduledDeliveryFee) * 100;  // Convert to cents
                const expressDeliveryFee = parseFloat(storedetails.areas[areaId].expressDeliveryFee) * 100;  // Convert to cents




                console.log('express delivery fee'+expressDeliveryFee);
                console.log('scheduledDeliveryFee'+scheduledDeliveryFee);

                // Set compliance details after fetching
                setComplianceDetails({
                    percentage: achPercentage,
                    value: achValue,
                });

                setDeliveryFeeDetails({
                    scheduled: scheduledDeliveryFee,
                    express: expressDeliveryFee,
                });

            })
            .catch(error => {
                console.error("Error fetching store details:", error);
            });

        if (error) {
            console.error('Error fetching cart details:', error);
        }
        if (data) {
            const newPriceSummary = JSON.parse(JSON.stringify(data.checkout.priceSummary));
            setCartItems(data.checkout.items);
            setPriceSummary(newPriceSummary);
        }
    }, [error, data, retailerId]);


    useEffect(() => {
        const fetchAndSetDeliveryDetails = (retryCount = 5) => {
            const almaUrl = "https://www.almapos.com/api/store_checkout_times";

            fetch(almaUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: `token=${retailerId}`
            })
                .then(response => response.json())
                .then(storedetails => {
                    var minimum = storedetails.minimum_spend;
                    window.minimum = minimum;
                    const deliveryMinElement = document.querySelector('.deliverymin');
                    if (deliveryMinElement) {
                        deliveryMinElement.textContent = `$${minimum}`;
                    }

                    const areaId = localStorage.getItem('areaId');
                    const achPercentage = parseFloat(storedetails.areas[areaId].ach_convenience_percentage) / 100;
                    const achValue = parseFloat(storedetails.areas[areaId].ach_convenience_value);

                    const scheduledDeliveryFee = parseFloat(storedetails.areas[areaId].scheduledDeliveryFee) * 100;
                    const expressDeliveryFee = parseFloat(storedetails.areas[areaId].expressDeliveryFee) * 100;

                    if (scheduledDeliveryFee && expressDeliveryFee) {
                        // Successfully retrieved delivery fee details, so set them
                        setComplianceDetails({
                            percentage: achPercentage,
                            value: achValue,
                        });

                        setDeliveryFeeDetails({
                            scheduled: scheduledDeliveryFee,
                            express: expressDeliveryFee,
                        });
                    } else if (retryCount > 0) {
                        // If data is incomplete or incorrect, retry after a delay
                        setTimeout(() => {
                            fetchAndSetDeliveryDetails(retryCount - 1);
                        }, 1000); // Retry after 1 second
                    } else {
                        console.error("Failed to fetch delivery fee details after multiple retries.");
                    }
                })
                .catch(error => {
                    console.error("Error fetching store details:", error);
                    if (retryCount > 0) {
                        // Retry if there's an error
                        setTimeout(() => {
                            fetchAndSetDeliveryDetails(retryCount - 1);
                        }, 1000);
                    }
                });
        };

        fetchAndSetDeliveryDetails();
    }, [retailerId]);



    // working on chrome vversiuobn
    useEffect(() => {
        const handleDeliveryMethodChange = () => {
            const selectedMethod = document.querySelector('input[name="input_19"]:checked')?.value;

            if (selectedMethod === 'scheduled') {
                console.log('set as scheduled delivery');
                setDeliveryFee(deliveryFeeDetails.scheduled || 5); // Default to 5 if not set
            } else if (selectedMethod === 'express') {
                console.log('set as express delivery');
                setDeliveryFee(deliveryFeeDetails.express || 10); // Default to 10 if not set
            }
        };

        const updateListeners = () => {
            const inputs = document.querySelectorAll('input[name="input_19"]');

            // Remove existing listeners to prevent duplicates
            inputs.forEach(input => {
                input.removeEventListener('change', handleDeliveryMethodChange);
                input.addEventListener('change', handleDeliveryMethodChange);
            });

            // Handle the initial selected method on load
            handleDeliveryMethodChange();
        };

        let mutationTimeout;
        const throttledMutationHandler = (mutationsList) => {
            let relevantChange = false;

            // Check if the relevant input elements were added or modified
            mutationsList.forEach(mutation => {
                if (
                    mutation.type === 'childList' &&
                    Array.from(mutation.addedNodes).some(node =>
                        node.querySelector?.('input[name="input_19"]')
                    )
                ) {
                    relevantChange = true;
                }
            });

            if (relevantChange) {
                if (mutationTimeout) clearTimeout(mutationTimeout);
                mutationTimeout = setTimeout(() => {
                    updateListeners();
                }, 100); // Throttle updates
            }
        };

        const observeFormChanges = () => {
            const formContainer = document.querySelector('.newcheckoutwrapper'); // Adjust this selector to your form container

            if (!formContainer || typeof MutationObserver === 'undefined') {
                console.warn('Form container not found or MutationObserver not supported.');
                return null;
            }

            const observer = new MutationObserver(throttledMutationHandler);

            observer.observe(formContainer, { childList: true, subtree: true });
            console.log('Observer attached to form container');
            return observer;
        };

        // Initial setup: attach listeners and handle current state
        updateListeners();

        // Observe DOM changes to handle dynamic updates
        const observer = observeFormChanges();

        // Cleanup on component unmount
        return () => {
            const inputs = document.querySelectorAll('input[name="input_19"]');
            inputs.forEach(input => input.removeEventListener('change', handleDeliveryMethodChange));

            if (observer) observer.disconnect();
            if (mutationTimeout) clearTimeout(mutationTimeout);
        };
    }, [deliveryFeeDetails]);



    useEffect(() => {
        const attachTipAmountListeners = () => {
            const tipDropdown = document.querySelector('#input_4_32') || document.querySelector('#input_5_32');
            const customTipInput = document.querySelector('#input_4_33') || document.querySelector('#input_5_33');

            const handleTipAmountChange = () => {
                const tipPercentage = parseInt(tipDropdown.value);
                const customTip = parseFloat(customTipInput.value) || 0;

                if (tipPercentage === -1) {
                    setTipAmount(customTip * 100);
                } else {
                    const subtotal = priceSummary?.subtotal || 0;
                    setTipAmount((subtotal * tipPercentage) / 100);
                }
            };

            if (tipDropdown && customTipInput) {
                tipDropdown.addEventListener('change', handleTipAmountChange);
                customTipInput.addEventListener('input', handleTipAmountChange);

                handleTipAmountChange();
            }
        };


        attachTipAmountListeners();

        const observer = new MutationObserver(() => {
            attachTipAmountListeners();
        });

        observer.observe(document, {
            childList: true,
            subtree: true
        });

        return () => {
            observer.disconnect();
        };
    }, [priceSummary]);

    useEffect(() => {
        if (priceSummary) {
            const discountElement = document.querySelector('input[name="input_44"]');
            if (discountElement) {
                discountElement.value = (priceSummary.discounts / 100).toFixed(2);
                discountElement.dispatchEvent(new Event('change', { bubbles: true }));
            }

            const taxesElement = document.querySelector('input[name="input_45"]');
            if (taxesElement) {
                taxesElement.value = (priceSummary.taxes / 100).toFixed(2);
                taxesElement.dispatchEvent(new Event('change', { bubbles: true }));
            }

            const subtotalElement = document.querySelector('input[name="input_47"]');
            if (subtotalElement) {
                subtotalElement.value = (priceSummary.subtotal / 100).toFixed(2);
                subtotalElement.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        const deliveryFeeElement = document.querySelector('input[name="input_46"]');
        if (deliveryFeeElement) {
            deliveryFeeElement.value = (deliveryFee / 100).toFixed(2);
            deliveryFeeElement.dispatchEvent(new Event('change', { bubbles: true }));
        }



        const complianceFeeElement = document.querySelector('input[name="input_48"]');
        if (complianceFeeElement) {
            complianceFeeElement.value = complianceFee.toFixed(2);
            complianceFeeElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }, [priceSummary, deliveryFee]);

    const onDrop = async (acceptedFiles) => {
        const file = acceptedFiles[0];
        const formData = new FormData();
        formData.append('file', file);

        try {
            await axios.post(UPLOAD_URL, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    const handleChangeQuantity = async (itemId, newQuantity) => {
        if (newQuantity === 0) {
            try {
                await removeItem({
                    variables: {
                        checkoutId,
                        itemId,
                        retailerId,
                    },
                });
                refetch();
            } catch (error) {
                console.error('Error removing item:', error);
            }
        } else {
            try {

                setErrorMessage("");


                await updateQuantity({
                    variables: {
                        checkoutId,
                        itemId,
                        quantity: newQuantity,
                        retailerId,
                    },
                });
                refetch();
            } catch (error) {
                console.error('Error updating quantity:', error);
            }
        }
    };

    const handleApplyCoupon = () => {
        const promocode = couponCode;
        const store = retailerId;
        const totalBeforeDiscount = (priceSummary?.subtotal + priceSummary?.taxes) / 100;
        const email = document.querySelector('input[name="input_5"]').value;

        const callbackName = `jsonp_callback_${Math.round(100000 * Math.random())}`;

        window[callbackName] = function(response) {
            delete window[callbackName];
            document.body.removeChild(script);

            if (response.error) {
                alert(response.error);
            } else {
                let discountAmount = 0;

                if (response.type === 'amount') {
                    discountAmount = parseFloat(response.value);
                } else if (response.type === 'percentage') {
                    const discountRate = parseFloat(response.value) / 100;
                    const calculatedDiscount = totalBeforeDiscount * discountRate;
                    discountAmount = parseFloat(calculatedDiscount.toFixed(2));
                }

                discountAmount = Math.min(discountAmount, totalBeforeDiscount);
                setOurDiscount(discountAmount * 100);
                setAppliedDiscount({ code: promocode, value: discountAmount });

                document.querySelector('input[name="input_37"]').value = response.code;
                document.querySelector('input[name="input_38"]').value = response.type;
                document.querySelector('input[name="input_39"]').value = discountAmount.toFixed(2);
            }
        };

        const url = `https://www.almapos.com/api/check_coupon?callback=${callbackName}&code=${promocode}&store=${store}&order_total=${totalBeforeDiscount}&email=${encodeURIComponent(email)}`;

        const script = document.createElement('script');
        script.src = url;
        document.body.appendChild(script);
    };

    const handleRemoveCoupon = () => {
        setCouponCode('');
        setAppliedDiscount(null);
        setOurDiscount(0);

        document.querySelector('input[name="input_37"]').value = '';
        document.querySelector('input[name="input_38"]').value = '';
        document.querySelector('input[name="input_39"]').value = '';

        refetch();
    };

    useEffect(() => {
        if (priceSummary) {
            const orderTotal = (priceSummary.subtotal + priceSummary.taxes - priceSummary.discounts - ourDiscount + deliveryFee) / 100 + complianceFee + tipAmount / 100;
            document.querySelector('input[name="input_30"]').value = orderTotal.toFixed(2);
            document.querySelector('input[name="input_31"]').value = (tipAmount / 100).toFixed(2);

            document.querySelector('input[name="input_30"]').dispatchEvent(new Event('change', { bubbles: true }));
            document.querySelector('input[name="input_31"]').dispatchEvent(new Event('change', { bubbles: true }));
        }
    }, [priceSummary, tipAmount, ourDiscount, deliveryFee, complianceFee]);

    useEffect(() => {
        var minimum = window.minimum;
        const minimumSpend = parseFloat(minimum);
        const totalAmount = ((priceSummary?.subtotal + priceSummary?.taxes - priceSummary?.discounts - ourDiscount + deliveryFee) / 100 + complianceFee + tipAmount / 100);

        const checkAndUpdateUI = () => {
            const noMinimumDiv = document.querySelector('.nominimum');
            const pageFooter = document.querySelector('.gform_page_footer');

            if (noMinimumDiv && pageFooter) {
                if (totalAmount < minimumSpend) {
                    noMinimumDiv.classList.remove('hidden');
                    pageFooter.classList.add('hidden');
                } else {
                    noMinimumDiv.classList.add('hidden');
                    pageFooter.classList.remove('hidden');
                }
                return true;
            }
            return false;
        };

        if (!checkAndUpdateUI()) {
            const intervalId = setInterval(() => {
                if (checkAndUpdateUI()) {
                    clearInterval(intervalId);
                }
            }, 100);

            return () => clearInterval(intervalId);
        }
    }, [priceSummary, tipAmount, ourDiscount, deliveryFee, complianceFee]);

    const onSubmit = async (data) => {
        // Define the submission logic here, including any GraphQL API calls
    };

    const handleButtonClick = () => {
        if (buttonText === 'Link New Account') {
            const addNewAccountButton = document.querySelector('.addnewstrong');
            if (addNewAccountButton) {
                addNewAccountButton.click();
            }
        } else if (buttonText === 'Pay with Stronghold') {
            const payWithStrongholdButton = document.querySelector('.paywithstronghold');
            if (payWithStrongholdButton) {
                payWithStrongholdButton.click();
            }
        } else {
            const originalButton = document.getElementById('gform_next_button_4_7') || document.getElementById('gform_next_button_5_7');
            if (originalButton) {
                originalButton.click();
            }
        }
    };

    const [bankName, setBankName] = useState("");
    const [agencyName, setAgencyName] = useState("");


    // Update agencyName based on the URL
    useEffect(() => {
        try {
            const url = new URL(window.location.href);
            // Split pathname into segments and filter out any empty strings
            const segments = url.pathname.split('/').filter(Boolean);
            // Assuming the format is: /checkout-new/{agencyId}/{...}
            const agencyId = segments[1] || "";
            let name = "Doobie"; // Default if not matched
            if (agencyId === "6257c1d3-1022-4250-9666-73644d762972") {
                name = "Travel Agency Union Square";
            } else if (agencyId === "9854f1ab-dab5-497c-b36a-a05a1968e5c5") {
                name = "Travel Agency Brooklyn";
            } else if (agencyId === "a8acceb2-b3be-4880-b89e-bc0143be8e12") {
                name = "Doobie Boston";
            }
            setAgencyName(name);
        } catch (err) {
            console.error("Error parsing URL:", err);
            setAgencyName("Doobie");
        }
    }, []);

    useEffect(() => {
        const originalButton =
            document.getElementById('gform_next_button_4_7') ||
            document.getElementById('gform_next_button_5_7');
        if (originalButton) {
            setButtonText(originalButton.value);

            const checkPageVisibilityAndUpdateButton = () => {
                const formPage5 = document.getElementById('gform_page_5_2');
                const formPage4 = document.getElementById('gform_page_4_2');
                const isPage2Visible =
                    (formPage5 && formPage5.style.display !== 'none') ||
                    (formPage4 && formPage4.style.display !== 'none');

                const checkInputSelection = () => {
                    const selectedInput = document.querySelector('input[name="input_27"]:checked');
                    if (!selectedInput || selectedInput.value === 'new') {
                        setButtonText('Link New Account');
                        setBankName(""); // Clear bankName if no valid selection
                    } else {
                        setButtonText('Pay with Stronghold');
                        const label = document.querySelector(`label[for="${selectedInput.id}"]`);
                        if (label && label.textContent.toLowerCase().includes("ending")) {
                            setBankName(label.textContent);
                        } else {
                            setBankName("");
                        }
                    }
                };

                if (isPage2Visible) {
                    checkInputSelection();
                } else {
                    setButtonText(originalButton.value);
                    setBankName("");
                }
            };

            // Run the check function once on mount
            checkPageVisibilityAndUpdateButton();

            // Use MutationObserver to listen for changes on the original button (if needed)
            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                        setButtonText(originalButton.value);
                    }
                });
                checkPageVisibilityAndUpdateButton();
            });

            observer.observe(originalButton, {
                attributes: true,
            });

            // Attach change listeners on the radio inputs
            const radioButtons = document.querySelectorAll('input[name="input_27"]');
            radioButtons.forEach(radio => {
                radio.addEventListener('change', checkPageVisibilityAndUpdateButton);
            });

            // Also re-run the check every 500ms in case of dynamic changes
            const visibilityCheckInterval = setInterval(() => {
                checkPageVisibilityAndUpdateButton();
            }, 500);

            // Cleanup on unmount
            return () => {
                observer.disconnect();
                clearInterval(visibilityCheckInterval);
                radioButtons.forEach(radio => {
                    radio.removeEventListener('change', checkPageVisibilityAndUpdateButton);
                });
            };
        }
    }, []);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <form id="react-checkout-form" onSubmit={handleSubmit(onSubmit)} className="flex-col mx-auto react-form-settings  rounded-lg">
            <h2 className="text-2xl font-bold font-good mb-4">Order Summary</h2>


            {errorMessage && (
                <div className="mb-4 p-4 bg-red-100 text-red-700 border border-red-300 rounded">
                    {errorMessage}
                </div>
            )}

            <div className="mb-4">
                {cartItems.map(item => (
                    <div key={item.id} className="flex items-center justify-between py-2 border-b">
                        <div className="flex items-center space-x-4">
                            <img
                                src={item.product.image}
                                alt={item.product.name}
                                className="new-product-image w-16 h-16 object-cover rounded"
                            />
                            <div>
                                <p className="font-semibold new-product-name">{item.product.name}</p>
                                <p className="text-sm text-gray-500 new-brand-name">{item.product.brand.name}</p>
                                <p className="text-sm text-gray-500 new-price">${item.product.variants[0].priceRec}</p>
                            </div>
                        </div>
                        <div className="flex items-center space-x-2">
                            {/* Decrement Button */}
                            <button
                                onClick={() => handleChangeQuantity(item.id, Math.max(item.quantity - 1, 0))}
                                className="px-2 py-1 border rounded text-gray-700 bg-gray-100 hover:bg-gray-200"
                                aria-label="Decrease quantity"
                            >
                                -
                            </button>

                            {/* Quantity Display */}
                            <span className="px-3 py-1 border text-center">{item.quantity}</span>

                            {/* Increment Button */}
                            <button
                                onClick={() => handleChangeQuantity(item.id, Math.min(item.quantity + 1, 10))}
                                className="px-2 py-1 border rounded text-gray-700 bg-gray-100 hover:bg-gray-200"
                                aria-label="Increase quantity"
                            >
                                +
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {appliedDiscount ? (
                <div className="mb-4 flex items-center">
                    <span className="border px-2 py-4 mr-2 bg-green-100 text-green-700 rounded-md">
                        {appliedDiscount.code}
                        <button
                            type="button"
                            onClick={handleRemoveCoupon}
                            className="ml-2 text-red-500 hover:text-red-700"
                        >
                            &times;
                        </button>
                    </span>
                </div>
            ) : (
                <div className="mb-4 flex items-start">
                    <input
                        type="text"
                        placeholder="Coupon Code"
                        value={couponCode}
                        onChange={(e) => setCouponCode(e.target.value)}
                        className="border px-2 py-4 mr-2"
                    />
                    <button
                        type="button"
                        onClick={handleApplyCoupon}
                        style={{
                            backgroundColor: '#072d41',
                            color: 'white'
                        }}
                        className="text-black py-4 px-4  bg-gray-800 text-white"
                    >
                        Apply
                    </button>
                </div>
            )}

            <div className="mb-4">
                <table className="w-full side-table-react">
                    <tbody>
                    <tr>
                        <td>Subtotal</td>
                        <td className="text-right">${(priceSummary?.subtotal / 100).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>Taxes</td>
                        <td className="text-right">${(priceSummary?.taxes / 100).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>Discounts</td>
                        <td className="text-right">${((priceSummary?.discounts + ourDiscount) / 100).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>Delivery Fee</td>
                        <td className="text-right">${(deliveryFee / 100).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>Compliance Fee</td>
                        <td className="text-right">${complianceFee.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>Tip Amount</td>
                        <td className="text-right">${(tipAmount / 100).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td className="text-right-larger"><strong>Total</strong></td>
                        <td className="text-right text-right-larger" ><strong>${((priceSummary?.subtotal + priceSummary?.taxes - priceSummary?.discounts - ourDiscount + deliveryFee) / 100 + complianceFee + tipAmount / 100).toFixed(2)}</strong></td>
                    </tr>
                    </tbody>
                </table>
            </div>





            <button
                type="button"
                className="gform_next_button gform-theme-button button flex items-center justify-center"
                onClick={handleButtonClick}
                disabled={loadingSpinner}
            >
                {loadingSpinner ? (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-6 h-6 spinner animate-spin"
                        fill="currentColor"
                    >
                        <path className="fa-secondary" opacity=".4" d="M0 256C0 114.9 114.1 .5 255.1 0C237.9 .5 224 14.6 224 32c0 17.7 14.3 32 32 32C150 64 64 150 64 256s86 192 192 192c69.7 0 130.7-37.1 164.5-92.6c-3 6.6-3.3 14.8-1 22.2c1.2 3.7 3 7.2 5.4 10.3c1.2 1.5 2.6 3 4.1 4.3c.8 .7 1.6 1.3 2.4 1.9c.4 .3 .8 .6 1.3 .9s.9 .6 1.3 .8c5 2.9 10.6 4.3 16 4.3c11 0 21.8-5.7 27.7-16c-44.3 76.5-127 128-221.7 128C114.6 512 0 397.4 0 256z"/>
                        <path className="fa-primary" d="M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"/>
                    </svg>
                ) : (
                    buttonText
                )}
            </button>



            {/* Conditionally render the bank name container */}
            {bankName && (
                <div id="stronghold-terms">
                    <p className="mt-4 text-sm">
                        By clicking Pay above, you agree to the{" "}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://ckjzj04.na1.hs-sales-engage.com/Ctc/5A+23284/ckJzj04/Jks2-6qcW69sMD-6lZ3lBW8zGCcx6Y91KRN28HNf_dg5zNN7dKZKL7c8f0N8_ykcZCMhWSW21xD3M3X9p9cW7lgBp23VpMZPW12QQ664ZcyfRW9cdBvh30tKMQW8rGRSX5MhbZwW5X8zf-6DhYXsW8Pc0yG7bjn8nW26sVxY3ZK2v7W2n0Cz_8jry4wW10dnrB5v2BK2W3QY8Vb5f3MhFW586KqM3B_11mW6CdwY_1p8LD-W6Mcz6x2hJNpPW8Mvt3h3wxzYfW7SvWz14zy1K2f8ww8Yx04"
                        >
                            Stronghold End User Terms of Service
                        </a>{" "}
                        and{" "}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://ckjzj04.na1.hs-sales-engage.com/Ctc/5A+23284/ckJzj04/Jks2-6qcW69sMD-6lZ3lBW8zGCcx6Y91KRN28HNf_dg5zNN7dKZKL7c8f0N8_ykcZCMhWSW21xD3M3X9p9cW7lgBp23VpMZPW12QQ664ZcyfRW9cdBvh30tKMQW8rGRSX5MhbZwW5X8zf-6DhYXsW8Pc0yG7bjn8nW26sVxY3ZK2v7W2n0Cz_8jry4wW10dnrB5v2BK2W3QY8Vb5f3MhFW586KqM3B_11mW6CdwY_1p8LD-W6Mcz6x2hJNpPW8Mvt3h3wxzYfW7SvWz14zy1K2f8ww8Yx04"
                        >
                            Privacy Policy
                        </a>
                        , and you authorize {agencyName} to make a one-time electronic debit
                        from your <strong>{bankName}</strong> for $
                        {(
                            (priceSummary?.subtotal +
                                priceSummary?.taxes -
                                priceSummary?.discounts -
                                ourDiscount +
                                deliveryFee) /
                            100 +
                            complianceFee +
                            tipAmount / 100
                        ).toFixed(2)}
                    </p>
                </div>
            )}

        </form>
    );
};

export default CheckoutForm;
